export class InvoicingModelModel {
  invoicingModelId: number = 0;
  conceptInvoicingType: number = 0;
  companyId: number = 0;
  consecutive: number = 0;
  description: string = "";
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}